import { useTheme } from '@/components/ThemeProvider';
import { cn } from '@/lib/utils';
import { useAppStore } from '@/store';
import { Reload } from '@/widget/Icon';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// 定义导航项类型
type NavItem = {
  path: string;
  label?: string;
  translationKey?: string;
};

// 导航项组件
const NavButton = ({ item, isActive, onClick }: { item: NavItem; isActive: boolean; onClick: () => void }) => {
  const { t } = useTranslation();
  const activeTradeStyle = 'bg-themeColor text-black h-full flex items-center justify-center';

  return (
    <div className={cn('flex-1 flex justify-center rounded-[8px] px-[8px]', isActive && activeTradeStyle)} onClick={onClick}>
      {item.translationKey ? t(item.translationKey) : item.label}
    </div>
  );
};

export default () => {
  const {
    fwClass,
    setTokenPath,
    chainInfo: { path },
  } = useAppStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();

  // 定义导航项
  const navItems: NavItem[] = [
    { path: `/${path}/token/signal`, translationKey: 'Token.signals' },
    { path: `/${path}/token/treasures`, translationKey: 'Token.treasures' },
    { path: `/${path}/token/meme`, label: 'Meme' },
    { path: `/${path}/token/trending`, translationKey: 'Token.trending' },
  ];

  useEffect(() => {
    setTokenPath(`/${path}/token/signal`);
  }, [path]);

  const handleNavigation = (path: string) => {
    setTokenPath(path);
    navigate(path);
  };

  return (
    <div className="px-[16px] mb-[70px] relative">
      <div className="flex items-center justify-between">
        <div
          className={cn(
            'h-[30px] text-[14px] flex items-center rounded-[8px] bg-[#F4F4F5] dark:bg-[#27272A] text-[#71717A] dark:text-[#A1A1AA]',
            fwClass,
          )}
        >
          {navItems.map((item) => (
            <NavButton key={item.path} item={item} isActive={pathname === item.path} onClick={() => handleNavigation(item.path)} />
          ))}
        </div>
        <Reload theme={theme} onClick={() => window.location.reload()} />
      </div>
      <Outlet />
    </div>
  );
};
